import { Form } from "antd";
import { Card } from "../ui";
export const SearchFormUi = ({
  initialValues = {},
  validationSchema = null,
  handleSubmit,
  ...props
}) => {
  return (
    <Card size="small" styles={{ body: { padding: "6px" } }}>
      <Form
        scrollToFirstError
        className="ant-advanced-search-form"
        initialValues={initialValues}
        onFinish={handleSubmit}
        {...props}
      />
    </Card>
  );
};
